/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Manage_DeletedInputs */

const en_us2_coach_manage_deleted = /** @type {(inputs: Coach_Manage_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation deleted`)
};

const pt_br2_coach_manage_deleted = /** @type {(inputs: Coach_Manage_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversa apagada`)
};

const es_419_coach_manage_deleted = /** @type {(inputs: Coach_Manage_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversación eliminada`)
};

const pt_pt2_coach_manage_deleted = /** @type {(inputs: Coach_Manage_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversa apagada`)
};

const fr_fr2_coach_manage_deleted = /** @type {(inputs: Coach_Manage_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation supprimée`)
};

const de_de2_coach_manage_deleted = /** @type {(inputs: Coach_Manage_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterhaltung gelöscht`)
};

const it_it2_coach_manage_deleted = /** @type {(inputs: Coach_Manage_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversazione eliminata`)
};

/**
* | output |
* | --- |
* | "Conversation deleted" |
*
* @param {Coach_Manage_DeletedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_manage_deleted = /** @type {((inputs?: Coach_Manage_DeletedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Manage_DeletedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_manage_deleted(inputs)
	if (locale === "es-419") return es_419_coach_manage_deleted(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_manage_deleted(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_manage_deleted(inputs)
	if (locale === "de-DE") return de_de2_coach_manage_deleted(inputs)
	if (locale === "it-IT") return it_it2_coach_manage_deleted(inputs)
	return en_us2_coach_manage_deleted(inputs)
});
export { coach_manage_deleted as "coach-manage.deleted" }